import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import Config from "../../config";
import createApp from "@shopify/app-bridge";
import { Redirect } from "@shopify/app-bridge/actions";
import { AppRoutes } from "../routes/route.path";
import { AuthService } from "../../services/AuthService";
import { UpdateIsShopify } from "../../actions";
import { useDispatch } from "react-redux";
import { ShopifyService } from "../../services/channels/ShopifyService";

const ShopifyAuthentication = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const params = new URLSearchParams(location.search);

    const hmac = params.get("hmac");
    const host = params.get("host");
    const shop = params.get("shop");
    const timestamp = params.get("timestamp");

    const apiKey = Config.SHOPIFY_KEY;
    const redirectUrl = `https://chatdev.falkon.ind.in/shopify/auth/callback`;
    const scopes = "write_script_tags,read_script_tags";

    const generateRandomString = () => Math.random().toString(36).substring(7);

    const authUrl = `https://${shop}/admin/oauth/authorize?client_id=${apiKey}&scope=${scopes}&redirect_uri=${redirectUrl}&state=${generateRandomString()}`;

    useEffect(() => {
        if (!shop || !host || !apiKey) {
            console.error("Missing required parameters for authentication.");
            return;
        }
        else {
            checkAccessToken();
        }
    }, [shop, host, apiKey]);

    const handleEmbeddedApp = () => {
        ShopifyService.RetrieveShopifyAcessToken(shop).then((res) => {
            if (res?.data?.token) {
                UpdateIsShopify(dispatch, {
                    shop,
                    shopify: true,
                    access_token: res.data.token,
                });
                navigate(
                    AuthService.isUserLoggedIn()
                        ? AppRoutes.CHANNELS
                        : AppRoutes.CHANNELS_SIGN_IN
                );
            }
        })
    }

    const handleNonEmbeddedApp = () => {
        const app = createApp({
            apiKey,
            host,
            forceRedirect: true,
        });

        // Redirect for authentication
        // Redirect.create(app).dispatch(Redirect.Action.REMOTE, authUrl);
        window.location.href = authUrl
    };

    const checkAccessToken = async () => {
        window.top === window.self
            ? handleNonEmbeddedApp()
            : handleEmbeddedApp();
    };

    return (
        <div className="w-p-100 h-p-100 d-flex justify-center align-center">
            Redirecting...
        </div>
    );
};

export default ShopifyAuthentication;
